<template>
	<div class="about">
		<el-row>
		  <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" :offset="2">
			  <div class="grid-content about">
				<div class="position">
					<el-breadcrumb separator-class="el-icon-d-arrow-right">
					  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  <el-breadcrumb-item>关于我们</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="content">
					  <el-row :gutter="10">
					    <el-col :xs="8" :sm="4" :md="4" :lg="4" :xl="4" :offset="2">
					  	  <div class="grid-content bg-purple left">
					  		  <div class="left-head">
					  			  <span>关于我们</span>
					  		  </div>
					  		  <router-link class="left-list" to="/about/jianjie">
					  			  <span>关于我们</span>
					  		  </router-link>
					  		  <router-link class="left-list" to="/about/paytype">
					  			 <span>付款方式</span>
					  		  </router-link>
							  <router-link class="left-list" to="/about/wzsm">
								 <span>网站声明</span>
							  </router-link>
							  <router-link class="left-list" to="/about/contact">
								 <span>联系我们</span>
							  </router-link>
					  	  </div>
					  	  </el-col>
					    <el-col :xs="14" :sm="16" :md="16" :lg="16" :xl="16">
					  	  <div class="grid-content right">
					  		<router-view></router-view>
					  	  </div>
					  	  </el-col>
					  </el-row>
				</div>
			</div>
		  </el-col>
		</el-row>
	</div>
</template>


<script>
	export default{
		name:'about',
		metaInfo() {
		  return {
			title: '关于我们 - ' + this.metaName,
			meta: [
			  { charset: "utf-8" },
			  { name: "keywords", content: this.metaKeywords },
			  { name: "description", content: this.metaDecs },
			],
		  };
		},
		data(){
			return{
				metaName: "",
				metaKeywords: "",
				metaDecs: "",
				tabPosition: 'left'
				
			}
		},
		mounted() {
			this.$axios({
				url:this.$utils.httpApi + 'index/webconfig'
			}).then(res=>{
				this.metaName = res.data.data.webtitle
				this.metaDecs = res.data.data.webdescription
				this.metaKeywords = res.data.data.webkeywords
			})
		},
	}
</script>

<style scoped>
	.left-head{
		width:100%;
		height:50px;
		background-color: #409EFF;
		color:#fff;
		line-height: 50px;
		font-size: 1.2rem;
	}
	.left-head span{
		padding-left: 10px;
	}
	.left-list{
		display: block;
		cursor: pointer;
		color: #409EFF;
		width:100%;
		height:40px;
		line-height: 40px;
		font-size: 1rem;
		border-bottom: #fff 1px dashed;
		text-decoration: none;
	}
	.left-list span{
		padding-left: 10px;
	}
	.el-col {
		border-radius: 4px;
	}
	.bg-purple-dark {
		background: #99a9bf;
	}
	.bg-purple {
		background: #d3dce6;
	}
	.bg-purple-light {
		background: #e5e9f2;
	}
	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}
	.content{
		margin-top:20px;
	}
	.tabpane{
		
	}
</style>